import { APP_INITIALIZER, ApplicationRef, DoBootstrap, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, provideHttpClient } from '@angular/common/http';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { SideBarComponent } from './shared/components/side-bar/side-bar.component';
import { StepperComponent } from './shared/components/stepper/stepper.component';
import { RegionSelectComponent } from './shared/components/region-select/region-select.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { CodState } from './cod/state/cod.state';
import { NgxsModule } from '@ngxs/store';
import { AuthService } from './auth/services/auth.service';
import { filter, Observable, tap } from 'rxjs';
import { AuthGmsAngularClientModule } from './auth/auth.module';
import { CodOverviewState } from './home/state/cod-overview.state';
import { CodReviewState } from './cod/state/cod-review.state';
import { UserState } from './user-management/state/user-management.state';
import { ReportState } from './report/state/report.state';
import { FooterComponent } from './shared/components/footer/footer.component';

export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        ReactiveFormsModule,
        SharedModule,
        AuthGmsAngularClientModule,
        NgxsModule.forRoot([CodState, CodOverviewState, CodReviewState, UserState, ReportState]),
        NgxsFormPluginModule.forRoot(),
        TranslateModule.forRoot({
            defaultLanguage: 'de',
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            }
        }),
        SideBarComponent,
        StepperComponent,
        HeaderComponent,
        RegionSelectComponent,
        FooterComponent
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: initializeAppFactory,
            deps: [AuthService],
            multi: true
        },
        provideHttpClient()
    ],
    bootstrap: [AppComponent]
})
export class AppModule implements DoBootstrap {
    constructor(private authService: AuthService) {}

    // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
    public ngDoBootstrap(appRef: ApplicationRef): void {
        this.authService.isAuthenticated$
            .pipe(
                filter(auth => !!auth),
                tap(() => appRef.bootstrap(AppComponent))
            )
            .subscribe();
    }
}

function initializeAppFactory(authService: AuthService): () => Observable<boolean> {
    return () =>
        authService.isAuthenticated$.pipe(
            filter(auth => !auth),
            tap(() => authService.login())
        );
}
